import type { FormErrors } from "@repo/shared-types";
import { useState } from "react";

export const useAsync = <T>(func: (...args: any[]) => Promise<T>) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<FormErrors>({});

  const execute = async (...args: any[]) => {
    setLoading(true);
    try {
      const result = await func(...args);
      setData(result);
      setError({});
    } catch (error: any) {
      if (error.init?.errors) {
        // TODO: This should be better to match the form errors type
        setError(error.init.errors);
      } else {
        setError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, execute };
};
